import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { log } from '~/services/logger.service';
const initialState = {
    text: null,
    type: null,
};
const AlertContext = createContext({
    ...initialState,
    setAlert: () => {
        return;
    },
});
export const AlertProvider = ({ children }) => {
    const [text, setText] = useState(null);
    const [type, setType] = useState(null);
    const setAlert = ({ type = null, text = null, rawError = new Error('Something went wrong.'), key = 'UNKNOWN', data = [], } = {}) => {
        setText(text);
        setType(type);
        if (type === 'error') {
            let errorMessage = JSON.stringify(rawError, Object.getOwnPropertyNames(rawError));
            if (rawError instanceof DOMException) {
                errorMessage = `DOM Exception - Name: ${rawError.name}, Message: ${rawError.message}`;
            }
            log(errorMessage, type, key, data);
        }
    };
    return (_jsx(AlertContext.Provider, { value: {
            text,
            type,
            setAlert,
        }, children: children }));
};
const useAlert = () => useContext(AlertContext);
export default useAlert;
